import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import HeroCarousel from "@/components/HeroCarousel";
import VideoInvite from "@/components/VideoInvite";
import Marquee from "@/components/Marquee";
import Countdown from "@/components/Countdown";
import Audience from "@/components/Audience";
import Manifesto from "@/components/Manifesto";
import KioskShowcase from "@/components/KioskShowcase";
import SpeakersTeaser from "@/components/SpeakersTeaser";
import Agenda from "@/components/Agenda";
import Sponsors from "@/components/Sponsors";
import HostSpotlight from "@/components/HostSpotlight";
import { scrollToSection } from "@/lib/scroll";

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const id = location.state.scrollTo;
      const t = setTimeout(() => scrollToSection(id), 300);
      return () => clearTimeout(t);
    }
  }, [location.state]);

  return (
    <main data-testid="home-page">
      <HeroCarousel />
      <VideoInvite />
      <Marquee />
      <Countdown />
      <Audience />
      <Manifesto />
      <KioskShowcase />
      <SpeakersTeaser />
      <Agenda />
      <Sponsors />
      <HostSpotlight />
    </main>
  );
};

export default Home;
